'use strict';

import NS from 'src/ns';
import $ from 'jquery';
import expanded from 'src/utility/expanded';
import forEach from 'lodash/each';
import assign from 'lodash/assign';
import matchMedia from 'src/utility/matchMedia';

class Project {
  constructor($target) {
    this.$block = $target;
    this.triggerButtonSelector = '[aria-controls*="stl-Expanded"]';
    this.expandedPanelSelector = '.stl-Item03__descriptionInner';
    this.ns = '.' + Project.BEM.block;
  }

  init() {
    matchMedia.register('tablet', {
      onMatch: function() {
        this.changeMode(false);
      }.bind(this),
      onUnMatch: function() {
        this.changeMode(true);
      }.bind(this)
    });
  }

  changeMode(isMobile) {
    let $buttons = this.$block.find(this.triggerButtonSelector);
    let $panels = this.$block.find(this.expandedPanelSelector);

    forEach($buttons, (button) => {
      this.changeButtonState($(button), isMobile);
    });

    forEach($panels, (panel) => {
      let $panel = $(panel);

      expanded._changePanelState($panel, !isMobile);
      $panel.attr('style', '');
    });
  }

  changeButtonState($button, isMobile) {
    let isHidden = !isMobile;
    let isSelected = false;

    $button
      .attr('aria-hidden', isHidden)
      .attr('aria-selected', isSelected);
  }
}

assign(Project, {
  BEM: {
    block: 'stl-Project',
    element: {},
    modifier: {}
  },
  create: function(element) {
    const $target = element ? $(element): $('.' + Project.BEM.block).first();

    if (!$target.length) return;

    new Project($target).init();
  },
  createAll() {
    let $target = $('.' + Project.BEM.block);

    if (!$target.length) return;

    forEach($target, (target) => {
      Project.create(target);
    });
  }
});


export default NS.Project = Project;


// WEBPACK FOOTER //
// ./htdocs/assets/src/javascripts/block/project.js